import { connect } from 'react-redux'
import { setMainContent, setActiveConversation } from 'actions'
import RecentConversations from './RecentConversations'
import Friends from './Friends'
import { setIsFullScreen } from 'actions/videoCall'
import {
  SectionContainer
} from './style'
import { addConversation } from 'actions/chat'

const Messages = (props) => {
  const { recentConversations, dispatch,
    currentActiveKey, setCurrentActiveKey,
    currentRightUser, user } = props

  const openChat = (conversation) => {
    dispatch(setMainContent('chat'))
    dispatch(setActiveConversation(conversation))
    dispatch(setIsFullScreen(false))
  }

  return (
    <div className='content__messages'>
      <SectionContainer>
        <RecentConversations
          user={user}
          openChat={openChat}
          currentRightUser={currentRightUser}
          currentActiveKey={currentActiveKey}
          setCurrentActiveKey={setCurrentActiveKey}
          recentConversations={recentConversations} />
      </SectionContainer>
      {/* <SectionContainer>
        <Friends
          openChat={openChat}
          currentRightUser={currentRightUser}
          currentActiveKey={currentActiveKey}
          setCurrentActiveKey={setCurrentActiveKey}
          recentConversations={recentConversations} />
      </SectionContainer> */}
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.connectionReducer.user,
  contentKey: state.mainContentReducer.contentKey,
  currentRightUser: state.chatReducer.currentRightUser,
  documentTitle: state.mainContentReducer.documentTitle
})

export default connect(mapStateToProps)(Messages)
